import { FC } from 'react';
import { Text } from '@servicetitan/anvil2';

export const TitleField: FC<{ title?: string }> = ({ title }) => {
    if (!title) {
        return null;
    }
    return (
        <Text variant="headline" el="h3" className="m-b-0-i">
            {title}
        </Text>
    );
};
